import JustificationForm					from "./JustificationForm";
import { useContext, useEffect, useState }	from "react";
import { useJustificationPage } 			from "../../contexts/JustificationPageContext";
import { UserContext }						from '../../contexts/UserContext';
import { usePushNotifications }				from '../../contexts/PushNotificationsContext';
import api									from '../../services/api';

function JustificationFormContainer (){

	const { 
		
		isJustificationFormOpen, 
		selectedComparisionId, 
		selectedJustificationId, 
		isJustificationFormEditMode ,
		
		handleUpadeComparisionTable, 
		handleUpdateJustificationTable,

		handerCloseJustificationForm, 

		handleSetSelectedJustificationId, 
		handlerSetJustificationFormEditMode,
		comparisionNumber

	} = useJustificationPage();


	
	const { userData } 						= useContext(UserContext);
	const { setContentPushNotification } 	= usePushNotifications()
	
	const [categorieId, setCategorieId] 				= useState(0);
	const [categories, setCategories] 					= useState({ 0: [],   1: [],   2: [],   3: [],   4: []   });
	const [selectedCategories, setSelectedCategories] 	= useState({ 0: null, 1: null, 2: null, 3: null, 4: null }); 
	const [initialValues, setInitialValues] 			= useState({});
	const [selectedLevel, setSelectedLevel] 			= useState(0);
	const [loading, isLoading] 							= useState(true)
	
	function __cleanAllNextOptions(level) {
		for (let i = level + 1; i < 5; i++) {		
			setCategories((prevCategories) => ({
				...prevCategories,
				[i]: []
			}))
		}
	}

	function __updateNextOptions (level, selectedCategories)  {
		setCategories((prevCategories) => ({
			...prevCategories,
			[level]: selectedCategories.map(item => ({ value: item.id, label: item.name }))
		}))
	}	

	function __updateSelectedCategories (currentPosition, selectedOption)  {
		setSelectedCategories(prevSelectedCategories => ({
			...prevSelectedCategories,
			[currentPosition]: selectedOption
		}));
	}

	function __cleanAllNextValues (currentPosition) {

		for (let i = currentPosition + 1; i < 5; i++) {
			setSelectedCategories(prevSelectedCategories => ({
				...prevSelectedCategories,
				[i]: null
			}));
		}

	}

	function __prepareDataToSubmit (formData, selectedCategories) {
			
		//obter o último item não nulo de um objeto
		const lastCategory = Object.keys(selectedCategories).reverse().map(key => selectedCategories[key]).find(item => item !== null);

		if (!lastCategory) {
			throw new Error('Selecione ao menos uma categoria antes de salvar.')
		}

		const data = {
			wagons: 		formData.wagons,
			description: 	formData.description,
			categoryId: 	lastCategory.value,
			userId: 		userData.id,
			comparisionId: 	selectedComparisionId
		}
		
		return data
	}

	function __fillFormData (formData) {

		const { categories } = formData;
		setInitialValues(formData);
		
		const options = categories
			.filter(item => item !== null) // Remove os valores nulos
			.map(item => ({ value: item.id, label: item.name }));

		for (let i = 0; i < options.length; i++) {
		
			handleCategoryChange(options[i], i)
		}

	}

	const fetchCategories = async () => {
		
		try {

			const response = await api.get(`/getCategoryList/${categorieId}`);
			
			const {selectedCategories, level} = response.data;
		
			selectedCategories.map(item => ({
				value: item.id,
				label: item.name
			}));

			__cleanAllNextOptions(level)

			__updateNextOptions(level, selectedCategories)

			isLoading(false)

		} catch (error) {	
			console.error("Error fetching categories:", error);
		}

	}

	const handleCategoryChange = async (selectedOption, position) => {
		
		if (selectedOption === null) {

			__updateSelectedCategories(position, null)

			selectedOption = Math.max(...Object.values(selectedCategories).filter(value => value !== null));
			
			setCategorieId(selectedOption.value)	
			
			__cleanAllNextValues(position-1)
		}
		else {
			setCategorieId(selectedOption.value)	
			__updateSelectedCategories(position, selectedOption)
			__cleanAllNextValues (position)
		}
	}

	const handleSubit = async (data) => {
		
		try {
			
			const justification = __prepareDataToSubmit(data, selectedCategories)

			if (isJustificationFormEditMode) {
				await api.put(`/updateJustification/${selectedJustificationId}`, { justification });
			}
			else{
				await api.post("/createJustification", { justification });
			}	


			handleUpdateJustificationTable()
			handleUpadeComparisionTable()
			handleCloseForm()
			
			setContentPushNotification({title: 'Sucesso', message: 'Justificativa criada com sucesso.'});

		} catch (error) {

			console.error("Error submitting justification:", error);
			setContentPushNotification({
				title: 'Erro', 
				message: error.response?.data?.message || error.message || 'Erro ao salvar justificativa.'
			});
		}

	}

	const fetchJustificationFormData = async () => {
		
		try {

			const response = await api.get(`/getJustificationById/${selectedJustificationId}`, {
				timeout:7000
			});
			const { justification } = response.data;
			__fillFormData(justification);

		} catch (error) {

			if (error.code === 'ECONNABORTED') {
				console.error("Timeout exceeded", error)
			}else {
				console.error("Error fetching justification data:", error);
			}
		}	
	}

	const handleCloseForm = () => {
		handerCloseJustificationForm()
		setSelectedCategories({ 0: null, 1: null, 2: null, 3: null, 4: null });
		handleSetSelectedJustificationId(null)
		handlerSetJustificationFormEditMode(false)
	}

	useEffect(() => {

		if (isJustificationFormOpen) {
			fetchCategories();
		} 

	}, [isJustificationFormOpen, categorieId])

	useEffect(() => {
		
		if (isJustificationFormOpen) {
			fetchJustificationFormData()
		}

	}, [selectedJustificationId])

	return (

		<JustificationForm 
			comparisionNumber={comparisionNumber}
			onSubmit={handleSubit}
			onClose={handleCloseForm}
			isOpen={isJustificationFormOpen}
			categories={categories}
			changeCategory={handleCategoryChange}
			setSelectedLevel={setSelectedLevel}
			selectedCategories={selectedCategories}
			initialValues={initialValues}
			isEditMode={isJustificationFormEditMode}
			loading={loading}
		/>
		
	);
}

export default JustificationFormContainer